const authorizeUtils = {
  // 是否模拟
  isSimulate: function () {
    let simulate = window['_simulate']
    return typeof simulate !== 'undefined' && simulate
  },
  // 模拟用户信息
  getUID: function () {
    return window['_uid'] || ''
  },
  // 获取access_token存放的key
  getAccessTokenKey: function () {
    if (this.isSimulate()) {
      return 'access_token_' + this.getUID()
    } else {
      return 'ws_access_token'
    }
  },
  // 获取refresh_token存放的key
  getRefreshTokenKey: function () {
    if (this.isSimulate()) {
      return 'refresh_token_' + this.getUID()
    } else {
      return 'ws_refresh_token'
    }
  },
  // 包装模拟信息，模拟登录时有效
  wrapParams: function (params) {
    if (this.isSimulate()) {
      params['_uid'] = this.getUID()
    }
    return params
  }
}

export default authorizeUtils



// WEBPACK FOOTER //
// ./src/util/authorizeUtils.js